import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import Clarity from "@microsoft/clarity";

import { loginWithToken } from "../../../../store/reducer/_sessionReducer";

import { PDLButton } from "../../../components/dna";
import { Logo } from "../../../components/global";

import { aaspAuth, ssoCallback } from "../../../../services";

import { jwtDecode } from "jwt-decode";
import { LexSsoAuthTokenPayload } from "../../../../models";
import { ssoUserManager } from "../../../../utils/sso";
import "../index.scss";

const SSOCallback = () => {
  const [error, setError] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAuth = async () => {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const code = searchParams.get("code");

      let token: string;

      if (code) {
        const response = await ssoCallback(code);

        token = response.token;
      } else {
        let accessToken = null;
        let idToken = null;

        try {
          const userSSO = await ssoUserManager.signinRedirectCallback();

          accessToken = userSSO?.access_token;
          idToken = userSSO?.id_token;
        } catch (oidcError) {
          const hash = window.location.hash;

          const params = new URLSearchParams(hash.replace("#", ""));

          accessToken = params.get("access_token");
          idToken = params.get("id_token");
        }

        if (!accessToken) {
          setError(true);
          return;
        }

        if (idToken) {
          sessionStorage.setItem("sso_id_token", idToken);
        }

        const response = await aaspAuth(accessToken);

        token = response.token;
      }

      const payload = jwtDecode(token) as LexSsoAuthTokenPayload;

      const user = {
        name: payload.name,
        email: payload.email,
        origem: payload.type,
        idPessoa: payload.userId,
      };

      Clarity.identify(String(user.idPessoa));
      Clarity.setTag("user_email", user.email);
      Clarity.setTag("user_origin", user.origem);
      Clarity.setTag(
        "user_sso_provider",
        payload?.provider || "Não identificado",
      );

      dispatch(
        loginWithToken({
          user,
          token,
        }),
      );

      window.history.replaceState({}, document.title, "/sso/callback");

      navigate("/home", {
        replace: true,
      });
    } catch (err) {
      console.error("Erro callback SSO:", err);

      setError(true);
    }
  };

  useEffect(() => {
    handleAuth();
  }, []);

  if (error) {
    return (
      <div className="auth-section">
        <Logo variant="lex" />

        <h2>Falha na autenticação</h2>

        <p>Não foi possível autenticar sua sessão.</p>

        <PDLButton onClick={() => navigate("/entrar")}>Voltar</PDLButton>
      </div>
    );
  }

  return (
    <div className="auth-section">
      <Logo variant="lex" />

      <h2>Autenticando...</h2>

      <p>Estamos validando sua sessão.</p>
    </div>
  );
};

export default SSOCallback;
